export const US_CITIZEN = "US_CITIZEN";
export const RESIDENT_ALIEN = "RESIDENT_ALIEN";
export const NONRESIDENT_ALIEN = "NONRESIDENT_ALIEN";

export const citizenshipTypeDisplay = {
  [US_CITIZEN]: "U.S. Citizen",
  [RESIDENT_ALIEN]: "Resident Alien",
  [NONRESIDENT_ALIEN]: "Non-Resident Alien",
};
